var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hfc-chicken") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hfc-chicken"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 1024,
    height: 1024
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#F06C00",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "219.91 723.04 245.92 764.17 483.84 764.17 729.08 764.17 754.91 723.04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.35,259.83 C427.63,270.936667 422.27,281.636667 422.27,291.93 C422.27,302.223333 427.63,312.913333 438.35,324 C449.07,335.106667 454.43,345.806667 454.43,356.1 C454.43,366.393333 449.07,377.093333 438.35,388.2",
    id: "Shape",
    stroke: "#F06C00",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.81,259.83 C562.09,270.936667 556.73,281.636667 556.73,291.93 C556.73,302.223333 562.09,312.913333 572.81,324 C583.53,335.106667 588.89,345.806667 588.89,356.1 C588.89,366.393333 583.53,377.093333 572.81,388.2",
    id: "Shape",
    stroke: "#F06C00",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.07,683.23 C684.26,667.11 716.44,613.16 704.94,562.72 C693.44,512.28 643.3,488.3 591.43,500.6 C552.63,509.8 523.51,545.88 504.07,608.84",
    id: "Shape",
    stroke: "#F06C00",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.09,525.81 L746.72,476.54",
    id: "Shape",
    stroke: "#F06C00",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#F06C00",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "750.84 448.24 746.72 476.26 770.9 479.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.86,502.7 C530.46,490.93 506.63,482 468.13,482 C355.13,482 288.56,560.1 288.56,668.63",
    id: "Shape",
    stroke: "#F06C00",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotFood);
export default __webpack_public_path__ + "static/media/HotFood.fdcf439198993ea2f18d73aa06e87533.svg";
export { ForwardRef as ReactComponent };